import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { logger } from '@springtree/eva-sdk-core-logger';
// tslint:disable-next-line: import-name
import React from 'react';
import { RecoilRoot } from 'recoil';
import userExpiration from './helpers/user-expiration.js';
import storage from './helpers/storage.js';
// tslint:disable-next-line: import-name
import EvaStateEndpointMonitor from './eva-state-endpoint-monitor.js';
import EvaStateLoader from './eva-state-loader.js';
import EvaStateUserTokenMonitor from './eva-state-user-token-monitor.js';
import applicationTokenState, { storageKey as applicationTokenStorageKey } from './state/core/application-token-state.js';
import { storageKey as userTokenStorageKey } from './state/current-user/current-user-token-state.js';
import { storageKey as endpointStorageKey } from './state/core/eva-endpoint-url-state.js';
// tslint:disable-next-line: function-name
export function EvaRecoilRoot(props) {
    // Set initial values if supplied
    //
    if (props.endpointUrl) {
        logger.debug('[STATE] setting endpoint', props.endpointUrl)();
        storage.setItem(endpointStorageKey, props.endpointUrl);
    }
    if (props.userToken) {
        logger.debug('[STATE] setting userToken', props.userToken)();
        storage.setItem(userTokenStorageKey, props.userToken);
    }
    if (props.applicationToken) {
        logger.debug('[STATE] setting applicationToken', props.userToken)();
        storage.setItem(applicationTokenStorageKey, props.applicationToken);
    }
    const endpoint = storage.getItem(endpointStorageKey) || '';
    const userToken = props.userToken || storage.getItem(userTokenStorageKey) || '';
    logger.debug('[STATE] current endpoint', endpoint)();
    logger.debug('[STATE] current user token', userToken)();
    const userTokenExpiredHandler = React.useCallback((expiredToken) => {
        logger.debug('[STATE] User token expired', expiredToken)();
        // Save the current user token so we can supply it to the callback
        //
        const currentToken = storage.getItem(userTokenStorageKey) || '';
        // This calls the user expired callback for the SDK consumer to also act
        // on an expired token.
        // The user token state helper below will unset it in the recoil atom
        //
        if (props.userExpiredCallback) {
            props.userExpiredCallback({
                expiredToken,
                currentToken,
            });
        }
    }, [props.userExpiredCallback]);
    // Listen for user expirations so we can unset the user token and update the recoil data
    //
    React.useEffect(() => {
        userExpiration.subscribe(userTokenExpiredHandler);
        return () => userExpiration.unsubscribe(userTokenExpiredHandler);
    }, [props.userExpiredCallback]);
    // Setup state loaders for the core state atoms to ensure the changes are reflected
    //
    return (_jsxs(RecoilRoot, { children: [_jsx(EvaStateLoader, { recoilState: applicationTokenState }), _jsx(EvaStateUserTokenMonitor, {}), _jsx(EvaStateEndpointMonitor, {}), props.children] }));
}
//# sourceMappingURL=eva-recoil-root.js.map